import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { LocalesActions } from './locales.actions';
import { SharedApiService } from '@emm/shared/services/shared-api.service';
import {catchError, map, switchMap, tap} from 'rxjs/operators';
import { of } from 'rxjs';
import {NotificationService} from '@emm/shared/services/notification.service';

@Injectable({ providedIn: 'root' })
export class LocalesEffects {

    constructor(
        private actions$: Actions,
        private api: SharedApiService,
        private notificationService: NotificationService
    ) {}

    loadLocaleOptions$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LocalesActions.loadLocaleOptions),
            switchMap(() =>
                this.api.getLocaleOptions().pipe(
                    map((localeOptions) => LocalesActions.loadLocaleOptionsSuccess({ localeOptions })),
                    catchError(({ error }) => of(LocalesActions.loadLocaleOptionsFailure({ error })))
                )
            )
        )
    );

    loadLocaleMappings$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LocalesActions.loadLocaleMappings),
            switchMap(() =>
                this.api.getLocaleMappings().pipe(
                    map((localeMappings) => LocalesActions.loadLocaleMappingsSuccess({ localeMappings })),
                    catchError(({ error }) => of(LocalesActions.loadLocaleMappingsFailure({ error })))
                )
            )
        )
    );

    loadAttributeLocaleFields$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LocalesActions.loadAttributeLocaleFields),
            switchMap(({ itemTag, attributeTag }) =>
                this.api.getAttributeLocaleFields(itemTag, attributeTag).pipe(
                    map((attributeLocaleFields) => LocalesActions.loadAttributeLocaleFieldsSuccess({ attributeLocaleFields })),
                    catchError(({ error }) => of(LocalesActions.loadAttributeLocaleFieldsFailure({ error })))
                )
            )
        )
    );

    saveAttributeLocaleFields$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LocalesActions.saveAttributeLocaleFields),
            switchMap(({ itemTag, updatedFields }) =>
                this.api.saveAttributeLocaleFields(itemTag, updatedFields).pipe(
                    map(() => LocalesActions.saveAttributeLocaleFieldsSuccess({itemTag})),
                    catchError(({ error }) => of(LocalesActions.saveAttributeLocaleFieldsFailure({ error })))
                )
            )
        )
    );

    saveAttributeLocaleFieldsSuccess$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LocalesActions.saveAttributeLocaleFieldsSuccess),
            map((action) => {
                const itemTag = action.itemTag;
                this.notificationService.success(`${itemTag} was successfully updated`);
                return {type: '[NO ACTION]'}; // Return a dummy action to satisfy the effect return type
            })
        )
    );

    saveAttributeLocaleFieldsFailure$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LocalesActions.saveAttributeLocaleFieldsFailure),
            tap(({ error }) => {
                const message = error?.error?.message ?? error?.message ?? error;
                this.notificationService.error(`Failed to save: ${message}`);
            })
        ),
        { dispatch: false }
    );

}
